import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import { useFormik } from 'formik';
import * as yup from 'yup';
import TextField from 'components/Common/TextField'
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox'
import Link from '@mui/material/Link'
import { PRIMARY_BUTTON } from 'themes/theme';
import CustomButton from 'components/Common/Button';
import Autocomplete from '@mui/material/Autocomplete';

const sx = {
    main: {
        margin: "0 50px"
    },

    checkbox: {
        color: '#BDBDCE',
        '&.Mui-checked': {
            color: '#0A78CD',
        },
    },

    continue: {
        textAlign: "center"
    }
}

const phoneRegex = RegExp(
    /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/
);

const validationSchema = yup.object({
    firstName: yup.string().required('Firstname is Required'),
    lastName: yup.string().required('Lastname is Required'),
    bizName: yup.string().required('Business name is Required'),
    bizState: yup.string().required('State is Required'),
    bizZip: yup
        .string()
        .matches(/^[0-9]+$/, 'Must be only digits')
        .min(5, 'Enter valid Zipcode')
        .max(6, 'Enter valid Zipcode')
        .required('Zipcode is Required'),

    bizPhone: yup
        .string()
        .matches(phoneRegex, 'Enter valid phone number')
        .required('Phone number is Required'),
})


export default function NavBusinessForm(props) {
    const stateValue = props.states.find(x => x.id.toLowerCase() === props.business?.bizState.toLowerCase() || x.label.toLowerCase() === props.business?.bizState.toLowerCase());

    const formik = useFormik({
        initialValues: {
            firstName: props.business?.firstName,
            lastName: props.business?.lastName,
            bizName: props.business?.bizName,
            bizState: stateValue?.id,
            bizZip: props.business?.bizZip,
            bizPhone: props.business?.bizPhone,
            updateProfileInfo: false
        },
        onSubmit: async () => {
            await props.onSubmit(formik.values)
        },
        validationSchema,
        enableReinitialize: true
    });

    function handleChange(fieldName, value) {
        formik.setFieldValue(fieldName, value.id)
    }


    return (
        <Box sx={sx.main}>
            <Box>
                <Grid container spacing={4}>
                    <Grid item xs={6}>
                        <TextField fullWidth label="First Name" variant="outlined" focused
                            name="firstName"
                            required
                            value={formik.values.firstName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.errors.firstName}
                            helperText={formik.errors.firstName}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField fullWidth label="Last Name" variant="outlined" focused
                            name="lastName"
                            required
                            value={formik.values.lastName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.errors.lastName}
                            helperText={formik.errors.lastName}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField fullWidth label="Business Name" variant="outlined" focused
                            name="bizName"
                            required
                            value={formik.values.bizName}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.errors.bizName}
                            helperText={formik.errors.bizName}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField fullWidth label="Phone Number" variant="outlined" focused
                            name="bizPhone"
                            required
                            value={formik.values.bizPhone}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.errors.bizPhone}
                            helperText={formik.errors.bizPhone}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <Autocomplete options={props.states}
                            name="bizState"
                            value={stateValue}
                            onChange={(_, value) => { handleChange("bizState", value) }}
                            onBlur={formik.handleBlur}
                            renderInput={(params) => <TextField {...params} variant="standard" required label="Business State" focused error={formik.errors.bizState}
                                helperText={formik.errors.bizState} />}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                        />
                    </Grid>
                    <Grid item xs={6}>
                        <TextField fullWidth label="Business Zip" variant="outlined" focused
                            name="bizZip"
                            required
                            value={formik.values.bizZip}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            error={formik.errors.bizZip}
                            helperText={formik.errors.bizZip}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <FormControlLabel name='updateProfileInfo' control={<Checkbox size="large" sx={sx.checkbox} defaultChecked={false} onChange={formik.handleChange} />}
                            label={
                                <Box color="#66668F" fontSize="12px" lineHeight={'20px'}>
                                    I would like this business information to be updated throughout my Dashboard
                                </Box>
                            }
                        />
                    </Grid>
                    <Grid item xs={12} sx={sx.continue}>
                        <CustomButton type={PRIMARY_BUTTON} onClick={formik.handleSubmit} loading={formik.isSubmitting}>
                            Continue
                        </CustomButton>
                    </Grid>
                    <Grid item xs={12}>
                        <Typography className="color-primary" component="span" variant="body2">
                            By clicking continue you are authorizing the sharing of your business information with Nav. For more
                            information, please reference the “Third-Party Applications and Services” section within our&nbsp;
                            <Link
                                rel="noreferrer"
                                href="https://markaaz.com/terms-and-conditions/"
                                target="_blank"
                                color="secondary"
                                underline="hover"
                                style={{ fontWeight: 'bold' }}
                            >
                                <Typography component="span" variant="body2B" color="secondary">
                                    Terms and Conditions
                                </Typography>
                            </Link>
                            .
                        </Typography>
                    </Grid>

                </Grid>
            </Box>
        </Box>
    )
}